var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 23,
    viewBox: "0 0 71 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2298 0.939999V22H19.0998V9.37L14.3898 22H10.2498L5.50978 9.34V22H0.379775V0.939999H6.43978L12.3498 15.52L18.1998 0.939999H24.2298ZM41.0288 18.28H33.1688L31.9088 22H26.5388L34.1588 0.939999H40.0988L47.7188 22H42.2888L41.0288 18.28ZM39.7088 14.32L37.0988 6.61L34.5188 14.32H39.7088ZM64.018 7.6C63.638 6.9 63.088 6.37 62.368 6.01C61.668 5.63 60.838 5.44 59.878 5.44C58.218 5.44 56.888 5.99 55.888 7.09C54.888 8.17 54.388 9.62 54.388 11.44C54.388 13.38 54.908 14.9 55.948 16C57.008 17.08 58.458 17.62 60.298 17.62C61.558 17.62 62.618 17.3 63.478 16.66C64.358 16.02 64.998 15.1 65.398 13.9H58.888V10.12H70.048V14.89C69.668 16.17 69.018 17.36 68.098 18.46C67.198 19.56 66.048 20.45 64.648 21.13C63.248 21.81 61.668 22.15 59.908 22.15C57.828 22.15 55.968 21.7 54.328 20.8C52.708 19.88 51.438 18.61 50.518 16.99C49.618 15.37 49.168 13.52 49.168 11.44C49.168 9.36 49.618 7.51 50.518 5.89C51.438 4.25 52.708 2.98 54.328 2.08C55.948 1.16 57.798 0.699999 59.878 0.699999C62.398 0.699999 64.518 1.31 66.238 2.53C67.978 3.75 69.128 5.44 69.688 7.6H64.018Z",
    fill: "#919699"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMag);
export default __webpack_public_path__ + "static/media/icon-mag.cc5d3fa42c7f1c174c699646ec72be6e.svg";
export { ForwardRef as ReactComponent };